import React from 'react';
import styles from './Testimonials.module.css';
import quoteImage from '../assets/quote.png';


function Testimonials() {
  return (
    <section className={styles.testimonials}>
      <h2 className={styles.sectionTitle}>Ord fra våre kunder</h2>
      <div className={styles.testimonialList}>
        <div className={styles.blockquotecontainer}>
          <img src={quoteImage} alt="quote" className={styles.blockquoteimg} />
          <blockquote>
          "Setter stor pris på all support og hjelp. Fine folk som tar oss på alvor selv om problemene kan virke banale. Alle får hjelp på sitt nivå."<br /><br />-Alta PPT
          </blockquote>
        </div>
        <div className={styles.blockquotecontainer}>
          <img src={quoteImage} alt="quote" className={styles.blockquoteimg} />
          <blockquote>
            "Den gjør arbeidshverdagen min enklere og forenklet. Bruker mye mindre tid på datamaskinen, og jeg kan være mer ute på skolene :)"<br /><br />-Alta PPT
          </blockquote>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
